import { Component, OnInit } from '@angular/core';
import { Profile } from 'src/app/shared/model/profile.model';
import { UserProfileService } from 'src/app/shared/services/user-profile.service';
import { AuthService } from '../../auth/service/auth.service';
import { MenuCategory } from 'src/app/core/layout/model/menuItem.model';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Router } from '@angular/router';
type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
}
@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss']
})

export class MainContentComponent implements OnInit {
  profile!: ProfileType;
  profileInfo?: Profile;
  apiCallTrigger = false;
  private tokenKey = 'auth-token';
  userGroups: any;
  lsUserInfo: any;
  lsUserRoles: any
  menuCategory: MenuCategory[] = [];

  constructor(
    private profileService: UserProfileService,
    private SsoPostInfo: AuthService,
    private router: Router,
    private apiService: SharedDataService,
  ) {
    const redirectUrl = localStorage.getItem('redirectUrl');
    if (redirectUrl) {
      this.apiService.loaderTrigger.next(true);
    }
  }

  ngOnInit(): void {
    console.log('--- INFORMATION --')
    this.getSSOUserGroup();
    const storedMenu = localStorage.getItem('menuData');
    if (storedMenu) {
      this.menuCategory = JSON.parse(storedMenu);
    }
    const locaUserInfo = localStorage.getItem('userInfo');
    if (locaUserInfo) {
      this.profileInfo = JSON.parse(locaUserInfo);
    }
    const userInfo = localStorage.getItem('user-information');
    if (userInfo) {
      this.profileInfo = JSON.parse(userInfo);
    } else {
      this.getProfile();
    }

    const menu = localStorage.getItem('menuData');
    if (menu) {
      this.menuCategory = JSON.parse(menu);
      console.log(this.menuCategory);
    }


  }
  getProfile() {
    this.profileService.getProfile().subscribe(response => {
      this.profileInfo = response;
      let userInfo: any = localStorage.getItem('user-information');
      if (userInfo) {
        if (this.profileInfo.mail) {
          userInfo = JSON.parse(userInfo);
          userInfo['emailAddress'] = this.profileInfo.mail;
          localStorage.setItem('user-information', JSON.stringify(userInfo));
        }
      };


    })
  }
  getSSOUserGroup() {
    this.SsoPostInfo.getGroup().subscribe({
      next: response => {
        const rolesinfo = response.value.map((group: { id: any; displayName: any; }) => ({
          ssoRoleId: group.id,
          roleName: group.displayName
        }));
        const rolesData = JSON.stringify(rolesinfo);
        localStorage.setItem('roles-information', rolesData);
        const storedDataJSON = localStorage.getItem('user-information');
        const rolesDataJSON = localStorage.getItem('roles-information');
        if (storedDataJSON && rolesDataJSON) {
          this.lsUserInfo = JSON.parse(storedDataJSON);
          this.lsUserRoles = JSON.parse(rolesDataJSON);
          console.table('Role Informatin List -> ', this.lsUserRoles);
          console.log('Role Count -> ', this.lsUserRoles.length);
        }
        this.getLocalToken(this.lsUserInfo, this.lsUserRoles);
      },
      error: error => {
        console.log('Request error');
      },
      complete: () => {
        console.log('Get Group Request complete');
      }
    });
  }
  getLocalToken(account: any, roles: any) {
    this.SsoPostInfo.sendUserInfo({ account, roles }).subscribe({
      next: response => {
        localStorage.setItem(this.tokenKey, response.data.token);
        this.menuCategory = response.data.featurecollection;
        localStorage.setItem('menuData', JSON.stringify(this.menuCategory));
        this.apiService.setApiCallTrigger(true);
        this.getAllFeaturesByCurrentUser();

      },
      error: error => {
        // console.log('Request complete');
      },
      complete: () => {
        // this.apiService.setApiCallTrigger(true);
        const storedMenu = localStorage.getItem('menuData');
        if (storedMenu) {
          this.menuCategory = JSON.parse(storedMenu);
        }
      }
    });
  }


  getAllFeaturesByCurrentUser() {
    this.SsoPostInfo.getAllFeaturesByCurrentUser().subscribe(info => {
      console.log(info);
      if (info) {
        localStorage.setItem('menuDataAll', JSON.stringify(info?.data));
      }
      const redirectUrl = localStorage.getItem('redirectUrl');
      if (redirectUrl) {
        this.apiService.loaderTrigger.next(false);
        // localStorage.removeItem('redirectUrl'); // Clear the stored URL after use
        this.router.navigateByUrl(redirectUrl);
        localStorage.removeItem('redirectUrl');
      }
    });
  }

}
